import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash.get';
import { Grid, InputLabel, MenuItem, Select, Typography, SelectChangeEvent } from '@kis-technologies/kis-ui';
import { selectors as configSelectors } from 'services/configuration';
import { useStyles } from '../styled';
import { SelectDropdownProps } from '../types';

export const SelectDropdown = (props: SelectDropdownProps) => {
  const { label, options = [], onChange, item, error, gridProps, selectInputProps } = props;

  const config = useSelector(configSelectors.selectConfiguration);
  const fontFamily = get(config, 'configuration.globalSettings.fonts.primary');

  const [value, setValue] = useState<string>(options.length ? options[0] : '');

  const classes = useStyles({ fontFamily, error })();

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const selectedValue = event.target.value as string;
    setValue(selectedValue);
    if (onChange && item) {
      onChange(selectedValue, item);
    }
  };

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 608,
        minWidth: 600,
        fontFamily
      }
    }
  };

  return (
    <Grid>
      <InputLabel className={classes.inputLabel}>{label}</InputLabel>
      <Grid className={classes.dropdownContainer} {...gridProps}>
        <Select
          value={options.includes(value) ? value : options[0]}
          onChange={handleChange}
          className={classes.dropdown}
          disableUnderline
          MenuProps={MenuProps}
          {...selectInputProps}
          variant="standard"
        >
          {options.map((option) => (
            <MenuItem key={option} value={option} className={classes.dropdownItem}>
              {option}
            </MenuItem>
          ))}
        </Select>
        {error && <Typography color="error">{error}</Typography>}
      </Grid>
    </Grid>
  );
};
